import {Link, useLocation, useParams} from 'react-router-dom';
import React, {useEffect, useState} from "react";
import DOMPurify from 'dompurify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, Pagination, Mousewheel, Keyboard } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import '../scss/home_page.scss';

import WOW from 'wow.js'
import 'wow.js/css/libs/animate.css'

import Marquee from "react-fast-marquee";

const Home = () =>{
    const [data, setData] = useState([]);
    const [settings, setSettings] = useState([]);

    useEffect(() => {
            fetch( global.config.api + `/?method=get_home_data`)
                .then(response => response.json())
                .then(json => {
                    if (json) {
                        setData(json);
                        setSettings(json.settings);
                    } else {
                        console.error('Invalid data structure', json);
                    }
                })
                .catch(error => console.error('Error fetching data:', error));
    }, []);

    const renderStars = (rating, show_number = true) => {
        const full_stars  = Math.floor( rating );
        const half_stars  = Math.ceil( rating - full_stars ) + full_stars;

        let all_stars = [];
        for (let i = 1; i <= 5; i++) {
            if( full_stars >= i){
                all_stars[i] = 'full';
            } else if ( half_stars >= i ){
                all_stars[i] = 'half';
            } else {
                all_stars[i] = 'empty';
            }
        }
        let rating_float = parseFloat(rating) + 0.001 ;

        return (<div className="star-rating"><span className="rating-text">{show_number ? rating_float.toFixed(1): ''}</span>
                {all_stars.map(star => (
                    <div className={'star star-' + star} aria-hidden="true"></div>
                ))}
            </div>
        );
    }

    const getPostThumbnail = (avatar) => {
        return avatar == '' ? '/wp-content/plugins/blog_tools/images/no_avatar.png' : avatar;
    }


    const checkHTML = (string) => {
        return DOMPurify.sanitize(string, { USE_PROFILES: { html: true } });
    }

    const buildMarueeLine = (content) => {
        if(Array.isArray(content)) {
            return(
                <Marquee className="marquee_wraper"
                    pauseOnHover="true"
                >
                    {content.map((item, index) => (
                        <div className="marquee_wraper_item">
                            <div className="marquee_wraper_item_icon">
                                <img src={getPostThumbnail(item.icon)} alt=""/>
                            </div>
                            <div className="marquee_wraper_item_name">{item.name}</div>
                            {renderStars(item.rating, false)}
                        </div>
                        ))
                    }
                </Marquee>
            )
        }
        return '';

    }

    const scrolToPageTop = () => {
        //window.scrollTo(0, 0);
        window.scrollTo({ top: 0, behavior: 'instant' });
    }

    const buildNewsSwiper = (content) => {
        if(Array.isArray(content)) {
            return (
                <div className="home_page_news_wraper_swiper">
                    <div className="swiper-button-group">
                        <div className="swiper-button-prev news_swiper" ></div>
                        <div className="swiper-button-next news_swiper" ></div>
                    </div>
                    <h2>Тор 10 новостей</h2>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={30}
                        width={444}
                        height={686}
                        navigation={{
                            prevEl: '.news_swiper.swiper-button-prev',
                            nextEl: '.news_swiper.swiper-button-next',
                        }}
                        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                    >
                        {content.map((item, index) => (
                            <SwiperSlide>
                                <a onClick={scrolToPageTop} href={'/#/news/' + item.link}>
                                    <img className="home_page_news_wraper_swiper_image" src={item.image} alt={item.title}/>
                                    <div className="home_page_news_wraper_swiper_index">{index + 1}</div>
                                    <div className="home_page_news_wraper_swiper_title">{item.title}</div>
                                </a>

                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )
        }
        return '';
    }

    const buildArticlesSwiper = (content) => {
        if(Array.isArray(content)) {
            return (
                <div className="container">
                    <div className="swiper-button-group">
                        <div className="swiper-button-prev articles_swiper" ></div>
                        <div className="swiper-button-next articles_swiper" ></div>
                    </div>
                    <h2>{settings.articles_title}</h2>
                    <Swiper
                        slidesPerView={3}
                        spaceBetween={30}
                        navigation={{
                            prevEl: '.articles_swiper.swiper-button-prev',
                            nextEl: '.articles_swiper.swiper-button-next',
                        }}
                        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                        breakpoints={{
                            320: {
                                slidesPerView: 1,
                                spaceBetween: 20
                            },
                            480: {
                                slidesPerView: 2,
                                spaceBetween: 10
                            },
                            1100: {
                                slidesPerView: 3,
                                spaceBetween: 20
                            },
                        }}
                    >
                        {content.map(item => (
                            <SwiperSlide>
                                <a onClick={scrolToPageTop} href={'/#/' + item.category + '/' + item.link}>
                                    <img src={item.image} alt={item.title}/>
                                </a>
                                <span>{item.title}</span>
                                <div className="home_page_recent_articles_info">
                                    <div className="home_page_recent_articles_info_date">{item.date}</div>
                                    <a href={'/#/' + item.category} className="home_page_recent_articles_info_cat">{item.category_name}</a>
                                </div>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )
        }
        return '';
    }

    var wow = new WOW({offset:100});
    wow.init({duration: 1000});


    const buildExchangeBlock = (content) => {
        if(content) {
            let background = 'background-image: url(' + content.image + ')';
            return (
                <div className="home_page_news_exchange_wraper wow fadeInUp" style={{backgroundImage: `url(${content.image})`}}>
                    <Link to={content.url}>
                        <h2>{content.title}</h2>
                        <p>{content.subtitle}</p>
                        <button className="outline_button">{content.button_title}</button>
                    </Link>
                </div>
            )
        } else {
            return '';
        }
    }

    const useGenerateRandomColor = () => {
        const [color, setColor] = useState("")
        const generateColor = () => {
            setColor(Math.random().toString(16).substr(-6));
        };
        return { color, generateColor };
    };


    const buildTagBlock = (content) => {
        if(content) {
            let taxonomies = content.taxonomies;
            let randomColor = '';
            return (
                <div className="home_page_news_exchange_articles wow fadeInUp">
                    <Link className="home_page_news_exchange_articles_title" to={content.url}>
                        <h2>{content.title}</h2>
                        <p>{content.subtitle}</p>
                        <button className="outline_button">{content.button_title}</button>
                    </Link>
                    <div className="home_page_news_exchange_articles_tags">
                        {taxonomies.map((item, index) => (
                            <Link className="outline_tag_button" to={item.slug}
                            style={{
                                borderColor: item.color,
                                color: item.color,
                                backgroundColor: `${item.color + '20'}`,
                            }}>{item.name}</Link>
                            ))
                        }
                    </div>
                </div>
            )
        } else {
            return '';
        }
    }

    const buildPriceBlock = (content) => {
        if (content) {
            return (
                <div className="home_page_pricees wow fadeInUp" style={{backgroundImage: `url(${content.image})`}}>
                    <div className="home_page_pricees_title">
                        <p>{content.subtitle}</p>
                        <Link to={content.url}>
                            <h2>{content.title}</h2>
                            <div className="outline_button">{content.button_title}</div>
                        </Link>
                    </div>
                </div>
            )
        } else {
            return '';
        }
    }

    const buildChoiseBlock = (content) => {
        if (content) {
            let feed = content.feed;
            return (
                <div className="home_page_featured_our_choice_wraper">
                    <p className="home_page_featured_our_choice_wraper_p">{content.subtitle}</p>
                    <h2 className="home_page_featured_our_choice_wraper_h2">{content.title}</h2>
                    <div className="home_page_featured_our_choice_wraper_overlay">
                        <div className="home_page_featured_our_choice_wraper_list">
                            {feed.map((item, index) => (
                                <a className="home_page_featured_our_choice_wraper_list_item" href={'/#/' + item.category + '/' + item.slug}>
                                    <img src={item.image} alt={item.post_title}/>
                                    <div className="home_page_featured_our_choice_wraper_list_item_info">
                                        <h3>{item.post_title}</h3>
                                        <p>{item.post_content}</p>
                                    </div>
                                </a>
                            ))}
                        </div>
                    </div>
                </div>
            )
        } else {
            return '';
        }
    }

    const buildPollsBlock = (content) => {
        if (content) {
            let feed = content.feed;
            let category = content.category;
            return (
                <div className="home_page_featured_polls_swiper">
                    <div className="swiper-button-group">
                        <div className="swiper-button-prev polls_swiper" ></div>
                        <div className="swiper-button-next polls_swiper" ></div>
                    </div>
                    <p className="home_page_featured_polls_swiper_p">{category.name}</p>
                    <h2 className="home_page_featured_polls_swiper_h2">{content.title}</h2>
                    <Swiper
                        slidesPerView={1}
                        spaceBetween={12}
                        navigation={{
                            prevEl: '.polls_swiper.swiper-button-prev',
                            nextEl: '.polls_swiper.swiper-button-next',
                        }}
                        modules={[Navigation, Pagination, Mousewheel, Keyboard]}
                    >
                        {feed.map((item, index) => (
                            <SwiperSlide>
                                <a onClick={scrolToPageTop} href={'/#/' + category.slug + '/' + item.slug}>
                                    <img src={item.image} alt={item.title}/>
                                    <div>
                                        <h3>{item.post_title}</h3>
                                        <p>{item.post_content}</p>
                                    </div>

                                </a>
                                <a className="outline_button" href={'/#/' + category.slug + '/' + item.slug}>{content.button_title}</a>
                            </SwiperSlide>
                        ))}
                    </Swiper>
                </div>
            )
        } else {
            return '';
        }
    }


    return (
        <div className="home_page">
            {buildMarueeLine(data.marquee_feed)}
            <div className="container">
                <div className="home_page_hero" >
                    <h1>{settings.h1}</h1>
                    <p>{settings.subtitle}</p>
                </div>
                <div className="home_page_recent_articles wow fadeIn">
                    <div className="similar_swiper">
                        {buildArticlesSwiper(data.recent_articles)}
                    </div>
                </div>
                <div className="home_page_news">
                    <div className="home_page_news_wraper wow fadeInUp">
                        {buildNewsSwiper(data.news_feed)}
                    </div>
                    <div className="home_page_news_exchange">
                        {buildExchangeBlock(settings.exchange_block)}
                        {buildTagBlock(settings.articles_block)}
                    </div>
                </div>
                {buildPriceBlock(settings.prices_block)}
                <div className="home_page_featured wow fadeInUp">
                    <div className="home_page_featured_our_choice">
                        {buildChoiseBlock(settings.featured_block)}
                    </div>
                    <div className="home_page_featured_polls">
                        {buildPollsBlock(settings.polls_block)}
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Home;